import { render, staticRenderFns } from "./appHall.vue?vue&type=template&id=377b1137&scoped=true&"
import script from "./appHall.vue?vue&type=script&lang=js&"
export * from "./appHall.vue?vue&type=script&lang=js&"
import style0 from "./appHall.vue?vue&type=style&index=0&id=377b1137&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b1137",
  null
  
)

export default component.exports